import PreviousButton from '../../atoms/PreviousButton/PreviousButton'
import Progressbar from '../../atoms/ProgressBar/ProgressBar'
import { useStartSurvey } from '../../../Hooks/useStartSurvey'
import LandingPage from '../../atoms/LandingPage/LandingPage'
import LoaderSpinner from '../../atoms/Loader/Loader'
import { NextButton } from '../../atoms/NextButton/NextButton'
import { RenderCommand } from '../../molecules/Render/RenderCommand'
import SurveyComplete from '../../molecules/SurveyComplete/surveyComplete'
import TimeOut from '../../organisms/Timeout/timeout'
import { useGlobalCtx } from '../../../Context/GlobalContext'
import { useSurveyCtx } from '../../../Context/SurveyContext'
import { Timer } from '../../atoms/Timer/Timer'
import BlockCommand from '../../molecules/Block/BlockCommand'
import { DataService_Domain_Models_ErrorCodes, DataService_Models_SurveyProgressBarType } from '../../../api'
import SurveyError from '../Error/SurveyError'
import { useEffect, useRef } from 'react'
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Error } from '@progress/kendo-react-labels'
import { languageResources } from '../../../Utils/messages'

// function SurveyEngineReducer(draft: UserResponse, action: DispatchAction) {
//   switch (action.type) {
//     case "addResponse":
//       const addIndex = draft.findIndex(response => response.commandIndex === action.value.commandIndex)
//       if (addIndex !== -1) draft.splice(addIndex, 1)
//       draft.push(action.value);
//       break;
//     case "removeResponse":
//       const index = draft.findIndex(response => response.commandIndex === action.value.commandIndex)
//       if (index !== -1) draft.splice(index, 1)
//       break;
//     case "clearResponse":
//       draft = [];
//       break;
//     default:
//       console.log("Unknown Action Value.")
//       break;
//   }
// }

export const Survey = () => {

  const globalCtx = useGlobalCtx();
  const surveyCtx = useSurveyCtx();

  const { getNextQuestionCommand, getPreviousQuestionCommand, getRefreshToken, getAbandonSurvey, getSubmitPendingConfirmation } = useStartSurvey();



  useEffect(() => {
    const handleAbandon = (surveyInstanceId: string) => {
      getAbandonSurvey(surveyInstanceId)
      console.log("Abandon");
    }

    if (surveyCtx.StartSurvey?.surveyInstanceId) {
      window.onbeforeunload = (ev) => {
        var doc = (ev.target as Document);
        if(!(doc.activeElement instanceof HTMLAnchorElement)){
          handleAbandon(surveyCtx.StartSurvey.surveyInstanceId!)
        }
      };

      window.onpagehide = (event) => {
        handleAbandon(surveyCtx.StartSurvey.surveyInstanceId!)
      };
    }

  }, [surveyCtx.StartSurvey])

  const showErrorPage = (error:DataService_Domain_Models_ErrorCodes) =>  {

    if(!error)
    {
      return false;
    }
    return [
        DataService_Domain_Models_ErrorCodes.STUDY_NOT_AVAILABLE,
        DataService_Domain_Models_ErrorCodes.INVALID_PANELIST_STATUS,
        DataService_Domain_Models_ErrorCodes.PANELIST_ALREADY_SURVEY_COMPLETED,
        DataService_Domain_Models_ErrorCodes.STUDY_QUOTA_IS_FULL,
        DataService_Domain_Models_ErrorCodes.CALENDAR_INTEGRATION_ERROR,
        DataService_Domain_Models_ErrorCodes.SURVEY_ENGINE_LEGACY_MODE_ON,
        DataService_Domain_Models_ErrorCodes.INVALID_PANELIST_PSGUID,
        DataService_Domain_Models_ErrorCodes.INVALID_STUDY_UID,
        DataService_Domain_Models_ErrorCodes.AUTHENTICATION_FAILURE,
        DataService_Domain_Models_ErrorCodes.AUTHORIZATION_FAILURE,
        DataService_Domain_Models_ErrorCodes.INTERNAL_ERROR,
        DataService_Domain_Models_ErrorCodes.SURVEY_INITILIZATION_ERROR
      ].includes(error);
  }

  let component = <LoaderSpinner fullScreen={true} />
  if ((globalCtx.StudyId === 0 && globalCtx.StudyIdentifier === '')) {
    component = <LandingPage />;
  }
  else if (globalCtx.LangResources !== null) {
    if (surveyCtx.IsAPIError && showErrorPage(surveyCtx.APIError.errorCode!)) {

    let message=""
    switch(surveyCtx.APIError.errorCode)
    {
      case DataService_Domain_Models_ErrorCodes.INVALID_PANELIST_STATUS:
      case DataService_Domain_Models_ErrorCodes.STUDY_QUOTA_IS_FULL:
      case DataService_Domain_Models_ErrorCodes.STUDY_NOT_AVAILABLE: 
      case DataService_Domain_Models_ErrorCodes.PANELIST_ALREADY_SURVEY_COMPLETED:
      case DataService_Domain_Models_ErrorCodes.INVALID_STUDY_UID:
        message = globalCtx.LangResources.errorMsg.studyNotAvalable??languageResources.en_US.errorMsg.studyNotAvalable;
        break;
      case DataService_Domain_Models_ErrorCodes.INVALID_PANELIST_PSGUID:
      case DataService_Domain_Models_ErrorCodes.AUTHENTICATION_FAILURE:
        message = globalCtx.LangResources.errorMsg.authenticationError??languageResources.en_US.errorMsg.authenticationError;
        break;
      case DataService_Domain_Models_ErrorCodes.AUTHORIZATION_FAILURE:
        message = globalCtx.LangResources.errorMsg.authorizationError??languageResources.en_US.errorMsg.authorizationError;
        break;
      case DataService_Domain_Models_ErrorCodes.SURVEY_ENGINE_LEGACY_MODE_ON:
        message = globalCtx.LangResources.errorMsg.legacyModeErrorMsg??languageResources.en_US.errorMsg.legacyModeErrorMsg;
        break;
      case DataService_Domain_Models_ErrorCodes.SURVEY_INITILIZATION_ERROR:
        message = globalCtx.LangResources.errorMsg.surveyInitilizationError??languageResources.en_US.errorMsg.surveyInitilizationError;
        break;                  
      default:
        message = globalCtx.LangResources.errorMsg.unExpectedError??languageResources.en_US.errorMsg.unExpectedError;
        break;  
    }
    component = <SurveyError messageHeader={globalCtx.LangResources.errorMsg.header??languageResources.en_US.errorMsg.header} messageTxt={message}/>

    }
    else if (surveyCtx.IsComplete) {
      if (surveyCtx.StartSurvey.panelistId && surveyCtx.StartSurvey.panelistId > 0 && globalCtx.App !== "qualmm") {
        //window.open(surveyCtx.RedirectUrl, '_parent')
        window.location.href = surveyCtx.RedirectUrl;
      }
      else {
        component = <SurveyComplete messageHeader={globalCtx.LangResources.thankYouMsg.header} messageTxt={globalCtx.LangResources.thankYouMsg.surveyMessage} />
      }
    }
    else if (surveyCtx.IsLoading) {
      component = <LoaderSpinner fullScreen={false} />;
    }
    else if (surveyCtx.IsTimeOut) {
      component = <TimeOut messageHeader={globalCtx.LangResources.timeOutMsg.header} messageTxt={globalCtx.LangResources.timeOutMsg.message} />
    }
    else if (surveyCtx.NextQuestion.commandIndex) {
      component = <>
        {surveyCtx.StartSurvey.surveyProgressBar && surveyCtx.StartSurvey.surveyProgressBar !== DataService_Models_SurveyProgressBarType.NONE && (
          // progress bar
          <Progressbar
            type={surveyCtx.StartSurvey.surveyProgressBar!}
            totalQuestions={surveyCtx.StartSurvey.commandCount as number}
            progressBarCount={surveyCtx.ProgressBarCounter}
            isSurveyComplete={surveyCtx.IsComplete}
          />
        )}
        {/* alert message */}
        <Timer studyId={surveyCtx.StartSurvey.studyId!} panelistId={surveyCtx.StartSurvey.panelistId!} postSurvey={false} refreshToken={getRefreshToken} abandonSurvey={getAbandonSurvey} timeOutMS={surveyCtx.StartSurvey.surveyTimeOutMs!} />
        {/* survey commands */}
        <div className="theme-survey-commands">
          {surveyCtx.NextQuestion.commandType === "Block" ?
            <BlockCommand NextQuestion={surveyCtx.NextQuestion} APIStatusCode={surveyCtx.APIStatusCode} ValidationErrors={surveyCtx.ValidationErrors} getNextQuestionCommand={getNextQuestionCommand} /> :
            <RenderCommand id={surveyCtx.NextQuestion.commandIndex} NextQuestion={surveyCtx.NextQuestion} APIStatusCode={surveyCtx.APIStatusCode} ValidationError={surveyCtx.ValidationErrors.find((e) => e.commandIndex === surveyCtx.NextQuestion.commandIndex)} focus={true}
              getNextQuestionCommand={getNextQuestionCommand}
              getSubmitPendingConfirmation={getSubmitPendingConfirmation} />}
        </div>

        {/* Button Controls*/}
        {surveyCtx.StartSurvey.surveyInstanceId && !surveyCtx.IsComplete && surveyCtx.NextQuestion.commandType !== "Recruit" && (
          <div className='theme-btn-container min-h-[5vh] block md:flex flex-row-reverse justify-between content-center pt-8 pb-2 mt-8'>
            <div className="md:flex-row ">
              <NextButton
                getNextQuestionCommand={getNextQuestionCommand}
                text={globalCtx.LangResources.controlMsg.nextButton ?? "Continue"} />
            </div>
            <div className="my-2 md:flex-row md:my-0">
              {surveyCtx.NextQuestion.showBackButton && (
                <PreviousButton
                  getPreviousQuestionCommand={getPreviousQuestionCommand}
                  text={globalCtx.LangResources.controlMsg.backButton ?? "Previous"}
                />
              )}
            </div>
          </div>
        )}
      </>
    }

  }
  
  // console.log('--------');
  // console.log(globalCtx.Theme);
  // console.log('--> survey.tsx');
  // console.log('--------');

  return (
    <div
      className="flex theme-survey-container fade-in px-5 py-6 sm:p-10 md:py-16 md:px-10 lg:py-16 lg:px-10 xl:py-16 xl:px-11 2xl:p-20 flex-col" data-testid="survey-container">
      {surveyCtx.IsAPIError && !showErrorPage(surveyCtx.APIError.errorCode!) && surveyCtx.NextQuestion.commandType !== undefined && !surveyCtx.IsLoading && !surveyCtx.IsTimeOut && !surveyCtx.IsComplete && globalCtx.LangResources !== null ?
        <Error className="theme-validator-error-text font-semibold" direction='start' id={"APIError"}>
          <FontAwesomeIcon icon={faCircleExclamation} className="theme-icon-spacer" />
          {globalCtx.LangResources.errorMsg.apiErrorMessage ?? "Your request could not be processes, Please try again."}
        </Error>
        : <></>
      }
      {component}
    </div>
  )


}